export default () => ({
  paymentIntentSecret: null,
  total: 0,
  subtotal: 0,
  coupon: null,
  paymentType: null
})
